const cogsVsClipsDailyLeagueId = "league_4a6999b2-6130-4489-987b-48d82ae769d2";
export const amongThemDailyLeagueId =
  "league_494db37d-d046-4cba-a99a-536b1439262f";
const crewriftDailyLeagueId = "league_605ff338-0a2e-4e62-aeda-559df9a9198f";
const cueNWooDailyLeagueId = "league_e28faac2-d187-4526-b73b-432c43943aed";

const apiBaseUrl = "https://softmax.com/api/observatory";

const playMarkdownAliases = [
  {
    source: "/play_cogsvsclips.md",
    leagueId: cogsVsClipsDailyLeagueId,
  },
  {
    source: "/play_amongthem.md",
    leagueId: amongThemDailyLeagueId,
  },
  {
    source: "/play_crewrift.md",
    leagueId: crewriftDailyLeagueId,
  },
  {
    source: "/play_cue_n_woo.md",
    leagueId: cueNWooDailyLeagueId,
  },
] as const;

/** The Observatory API path of one league's participation guide. */
export function participationGuidePath(leagueId: string): string {
  return `/v2/participate?league_id=${encodeURIComponent(leagueId)}`;
}

export function leagueParticipationGuideUrl(leagueId: string): string {
  return `${apiBaseUrl}${participationGuidePath(leagueId)}`;
}

export function playMarkdownAliasRedirects() {
  return playMarkdownAliases.map(({ source, leagueId }) => ({
    source,
    destination: leagueParticipationGuideUrl(leagueId),
    permanent: false,
  }));
}
